import { AxiosResponse } from "axios";
import { oc } from "ts-optchain";

import { DealernetApi } from "./DealernetApi";

import { IAccountContext, IPartListBuilderResponseDto, Nullable } from "@/types";

const CONTROLLER_PATH = "PartListBuilder";

export class PartListBuilderService {
  public static async GetPartList(data: IGetPartListBuilderRequest): Promise<IPartListBuilderResponseDto | undefined> {
    const response = await DealernetApi.client().request({
      method: "post",
      url: `${CONTROLLER_PATH}/GetPartListBuilder`,
      data,
      timeout: 60000, // 60000 milliseconds = 60 seconds timeout
    });

    return oc(response as AxiosResponse<IPartListBuilderResponseDto>).data();
  }

  public static async AddItemToList(data: IAddPartListBuilderRequest): Promise<boolean | undefined> {

    const response = await DealernetApi.client().request({
      method: "post",
      url: `${CONTROLLER_PATH}/AddCompressedPartListItem`,
      data,
    });

    return oc(response as AxiosResponse<boolean>).data();
  }

  public static async UpdateListItem(data: IUpdatePartListItemRequest): Promise<IPartListBuilderResponseDto | undefined> {
    const response = await DealernetApi.client().request({
      method: "post",
      url: `${CONTROLLER_PATH}/UpdatePartListItem`,
      data,
    });

    return oc(response as AxiosResponse<IPartListBuilderResponseDto>).data();
  }

  public static async DeleteItems(data: IDeletePartListItemsRequest): Promise<IPartListBuilderResponseDto | undefined> {
    const response = await DealernetApi.client().request({
      method: "post",
      url: `${CONTROLLER_PATH}/DeletePartListItems`,
      data,
    });

    return oc(response as AxiosResponse<IPartListBuilderResponseDto>).data();
  }

  public static async AddCrossReference(data: any ): Promise<IPartListBuilderResponseDto | undefined> {
    const response = await DealernetApi.client().request({
      method: "post",
      url: `${CONTROLLER_PATH}/AddCrossReference`,
      data,
    });

    return oc(response as AxiosResponse<IPartListBuilderResponseDto>).data();
  }

  public static async GetCrossReferences(data: IGetCrossReferencesRequest): Promise<any | undefined> {
    const response = await DealernetApi.client().request({
      method: "post",
      url: `${CONTROLLER_PATH}/GetCrossReferences`,
      data,
    });

    return oc(response as AxiosResponse<any>).data();
  }
}

export interface IGetPartListBuilderRequest extends IAccountContext {
  partListId?: Nullable<string|number>;
  userAudiences: number[];
  removeHyphenSearch: boolean;
}

export interface IAddPartListBuilderRequest extends IAccountContext {
  partListId: string | number;
  userAudiences: number[];
  dealerPartNumber: Nullable<string>;
  oemId?: number;
  oemPartCode: Nullable<string>;
  quantity: Nullable<number>,
  stockingLocation: Nullable<string>;
}

export interface IUpdatePartListItemRequest extends IAccountContext {
  itemId: number;
  item: {
    itemId: number;
    dealerPartNumber: Nullable<string>;
    oemId?: number;
    oemPartCode: Nullable<string>;
    quantity: Nullable<number>,
    stockingLocation: Nullable<string>;
  },
  hideCrossSearch?: boolean,
  partListId: number;
  userAudiences: number[];
}

export interface IDeletePartListItemsRequest extends IGetPartListBuilderRequest {
  itemIds: number[];
}

export interface IGetCrossReferencesRequest extends IGetPartListBuilderRequest {
  accountId: number;
  userId: number;
  oemPartCode: number;
}